
import { useEffect, useState } from "react";
import TimeClock from "../../components/TimeClock";
import mut from "../../hooks/mut";
import { useContext } from "react";
import { ClassesContext } from "../../../../Context";
import useDBO from "../../hooks/useDBO";
import useCTX from "../../hooks/useCTX";
import HtClass from "../class/HtClass";
import PremiumStaffSelect from "../../components/PremiumStaffSelect";
import PremiumSelect from "../../components/PremiumSelect";
import Lang from "../../components/Lang";
import { differenceInMinutes } from "date-fns";




  const initialState = () => {
    return {
      staffId: "",
      startTime: "",
      endTime: "",
      hours: 0,
      htClass: "",
      role: ""
    };
  };
export default function NewShiftDialog(props) {
    const { open, setOpen, showDate, shifts } = props;
    const [state, setState] = useState(initialState());
    const [hours, setHours] = useState(0)
  const [disabled, setDisabled] = useState(false)
  const [reason, setReason] = useState("")
  const [details,setDetails] = useState("")
  const { locations } = useCTX()
  const {findClass} = useContext(ClassesContext)
  let location = locations[localStorage.getItem("location") ? localStorage.getItem("location") : 0]
  const classes = useDBO(`/lessons-on-date/${showDate}/${location._id}`);
/*   let tcs = []
  if(location) tcs = todaysClasses(location._id); */
  


    useEffect(() => {
        const hrs = (differenceInMinutes(new Date("2024-01-01 "+state.endTime), new Date("2024-01-01 "+state.startTime))/60).toFixed(2)
        let dis = false
        if (!state.staffId || !state.startTime || !state.endTime || hrs <= 0.1 || !state.role) dis = true
      if (state.staffId && state.startTime && state.endTime) {
        const sh = shifts.filter(s => s.user === state.staffId)
        for (let s of sh) {
          const sStart = toMinutes(s.startTime);
          const sEnd = toMinutes(s.endTime);
          const newStart = toMinutes(state.startTime);
          const newEnd = toMinutes(state.endTime);

          const overlap = sStart < newEnd && sEnd > newStart;

          if (overlap) {
            dis = true;
            setReason(
              `Sự thay đổi này trùng lặp với một sự thay đổi khác`
            );
            setDetails(
              `${s.startTime} - ${s.endTime}, ${
                s.htClass ? findClass(s.htClass).name : ""
              }, ${locations.find(l=>l._id===s.location).name}, ${s.role}`
            );
            break;
          }
        }

        if (!dis) {
          setReason("");
          setDetails("")
        }

      }
        setDisabled(dis)
        setHours(hrs)
    },[state, shifts, findClass, locations])
   console.log(classes)

  if (!open) return null;

  return (
    <div className="ht-modal-overlay" onClick={() => setOpen(false)}>
      <div className="ht-modal-paper" onClick={(e) => e.stopPropagation()}>
        <header className="ht-modal-header">
          <Lang w="addANewShift" />
        </header>
        <div className="glass-dialog-content">
          <PremiumStaffSelect
            value={state.staffId}
            setValue={(staffId) => setState((prev) => ({ ...prev, staffId }))}
            label="staffMember"
          />
          <div className="glass-dialog-row">
            <TimeClock
              value={state.startTime}
              setValue={(startTime) =>
                setState((prev) => ({ ...prev, startTime }))
              }
              label="startTime"
            />
            <TimeClock
              value={state.endTime}
              setValue={(endTime) => setState((prev) => ({ ...prev, endTime }))}
              label="finishingTime"
            />
          </div>

          <div className={`glass-dialog-hours ${hours > 0 ? "valid" : "invalid"}`}>
            <Lang w="hours" />: {hours > 0 ? hours : "incorrect"}
          </div>

          {(reason || details) && (
            <div className="dialog-error-box">
              <div>{reason}</div>
              <div>{details}</div>
            </div>
          )}

          <PremiumSelect
            value={state.role}
            setValue={(role) => setState((prev) => ({ ...prev, role }))}
            choices={choices}
            label={<Lang w="role" />}
          />
          <PremiumSelect
            value={state.htClass}
            setValue={(htClass) => setState((prev) => ({ ...prev, htClass }))}
            choices={
              classes.loading || classes.error
                ? []
                : classes.map((c) => ({
                    _id: c.htClass._id,
                    name: c.htClass.name,
                  }))
            }
            label={<Lang w="class" />}
          />
        
        </div>
        <footer className="ht-modal-actions">
          <button
            type="button"
            className="ht-btn ht-btn-cancel"
            onClick={() => {
              setState(initialState());
              setReason("");
              setDetails("");
              setOpen(false);
            }}
          >
            Close
          </button>
          <button
            type="button"
            className="ht-btn ht-btn-primary"
            disabled={disabled}
            onClick={async () => {
              let res = await mut("post", `/staff/shifts/`, {
                ...state,
                location: localStorage.getItem("location"),
                tDate: showDate,
                hours,
              });
              shifts.set(res);
              setState(initialState());
              setReason("");
              setDetails("");
              setOpen(false);
            }}
          >
            Save Shift
          </button>
        </footer>
      </div>
    </div>
  );
}

const choices = [
  "Giáo viên parttime",
  "Trợ giảng partime",
  "Gia sư",
  "Giáo viên nước ngoài",
  "Trợ lý học thuật",
  "Trợ lý văn phòng",
  "Làm sách",
  "Làm PPT",
  "Nhân viên sales",
  "Marketing"
];

function toMinutes(t) {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}
